module.exports = __webpack_public_path__ + "static-v-shop/1785872208163/img/logo_cabal.f797e5ff.png";